import './InlineHeader.sass';

import React, { FC } from 'react';
import { InlineHeaderProps } from './InlineHeader.interface';
import { classNames } from '$utils';

export const InlineHeader: FC<InlineHeaderProps> = ({
  children,
  counter = null,
  caption = null,
  type = 'normal',
}) => {
  return (
    <div
      className={classNames('InlineHeader', {
        _sub: type === 'sub',
      })}
    >
      <div
        className={classNames('InlineHeader__title', {
          _sub: type === 'sub',
        })}
      >
        {children}
        {!!counter && <div className="InlineHeader__counter">{counter}</div>}
      </div>
      {!!caption && <div className="InlineHeader__caption">{caption}</div>}
    </div>
  );
};
